import React from 'react';
import { Link } from 'react-router-dom';
import { Props } from './CommissionListingItem.types';
import styles from './CommissionListingItem.module.scss';
import { COMMISSION_TERM_TYPE, COMMISSION_TERM_TYPE_LABEL } from 'modules/commission_terms/api/types';

const CaseListingItem: React.FC<Props> = ({ commissionItem }) => {
  const formatType = (commissionType: string) => {
    if (commissionType === COMMISSION_TERM_TYPE.STANDARD) {
      return COMMISSION_TERM_TYPE_LABEL.STANDARD;
    }
    if (commissionType === COMMISSION_TERM_TYPE.ENHANCED) {
      return COMMISSION_TERM_TYPE_LABEL.ENHANCED;
    }
    if (commissionType === COMMISSION_TERM_TYPE.ONGOING) {
      return COMMISSION_TERM_TYPE_LABEL.ONGOING;
    }

    throw new Error(`Invalid commission type provided (${commissionType})`);
  };

  return (
    <div className={styles.item}>
      <div className={styles.wrapper}>
        <div className={styles.details}>
          <p className={styles.title}>{commissionItem.name}</p>
          <p className={styles.meta}>
            <span>{formatType(commissionItem.type)}</span>
          </p>
        </div>
        <div className={styles.additionalDetails}>
          <Link className={styles.linkBtn} to={`/panel/commission-terms/${commissionItem.id}`}>
            Update
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CaseListingItem;
